module.exports = __webpack_public_path__ + "cce02e5aa91b7b11facf6e844ac8e0b1.png";